export default __webpack_public_path__ + "static/media/payment-method.ca667366.png";